export default {
  FlightBookingForm__ARRIVE_LABEL: "Arrive*",
  FlightBookingForm__BUTTON_CLOSE: "Close",
  FlightBookingForm__BUTTON_SEARCH_FLIGHTS: "Search flights",
  FlightBookingForm__DATE_FORMAT: "MM/DD/YYYY",
  FlightBookingForm__DAY_OF_WEEK_MONTH_AND_YEAR: "ddd, MMM DD, YYYY",
  FlightBookingForm__DAYS_OF_WEEK_INITIALS: "SMTWTFS",
  FlightBookingForm__DEPART_BUTTON_TEXT: "DEPART",
  FlightBookingForm__DEPART_DATE_ARIA_LABEL: "Depart date in M M, D D format",
  FlightBookingForm__DEPART_DATE_LABEL: "Depart date*",
  FlightBookingForm__DEPART_LABEL: "Depart*",
  FlightBookingForm__DESTINATION_CITY_1_LABEL: "Destination 1*",
  FlightBookingForm__DESTINATION_CITY_2_LABEL: "Destination 2",
  FlightBookingForm__FARE_TYPE_CASH: "$",
  FlightBookingForm__FARE_TYPE_CASH_PLUS_POINTS: "$ + Points",
  FlightBookingForm__FARE_TYPE_POINTS: "Points",
  FlightBookingForm__FULL_MONTH_DAY_YEAR: "MMMM DD, YYYY",
  FlightBookingForm__INFO_ACCEPTING_RESERVATIONS: (airDatesData) =>
    `Now accepting reservations through ${airDatesData.formattedCurrentLastDateString}.`,
  FlightBookingForm__INFO_LAST_BOOKABLE_DATE: (airDatesData) =>
    `We are currently accepting air reservations through ${airDatesData.formattedCurrentLastDateString}.`,
  FlightBookingForm__INFO_OPEN_SCHEDULE: (airDatesData) =>
    `On ${airDatesData.formattedFutureOpenDateString} we will open our schedule for sale through ${airDatesData.formattedFutureCloseDateString}.`,
  FlightBookingForm__INVALID_ROUTE_TEXT: "Invalid route with departure airport",
  FlightBookingForm__LINK_BAGGAGE_AND_OPTIONAL_FEES: "Baggage & optional fees",
  FlightBookingForm__LINK_BOOK_WITH_SWABIZ: "Book with SWABIZ",
  FlightBookingForm__MULTIICTY_LABEL: "Multi-city",
  FlightBookingForm__NO_MATCH_FOUND_TEXT: "No match found",
  FlightBookingForm__ONEWAY_LABEL: "One-way",
  FlightBookingForm__PASSENGERS_LABEL: "Passengers*",
  FlightBookingForm__PASSENGER_SELECTOR_ADULTS_ARIA_LABEL: (data) =>
    `To book more than ${data.maxPassengersCount} adult passengers please call 1-800-433-5368.`,
  FlightBookingForm__PASSENGER_SELECTOR_ADULTS_CAPTION: "18+",
  FlightBookingForm__PASSENGER_SELECTOR_ADULTS_LABEL: "Adults",
  FlightBookingForm__PASSENGER_SELECTOR_ADULTS_INFO: (data) =>
    `To book more than ${data.maxPassengersCount} adult passengers please call 1-800-433-5368.`,
  FlightBookingForm__PASSENGER_SELECTOR_ARIA: "Passenger Selector",
  FlightBookingForm__PASSENGER_SELECTOR_CHILDREN_LABEL: "Children",
  FlightBookingForm__PASSENGER_SELECTOR_LAPCHILD_CAPTION: "Age 0-2",
  FlightBookingForm__PASSENGER_SELECTOR_LAPCHILD_LABEL: "Lap children",
  FlightBookingForm__PASSENGER_SELECTOR_LAPCHILDREN_ARIA_LABEL:
    "A child over 14 days old and under 2 years of age on the date of travel may be carried on the lap of an accompanying Passenger 12 years of age or older. Taxes and fees may apply.",
  FlightBookingForm__PASSENGER_SELECTOR_LAPCHILDREN_INFO:
    "A child over 14 days old and under 2 years of age on the date of travel may be carried on the lap of an accompanying Passenger 12 years of age or older. Taxes and fees may apply.",
  FlightBookingForm__PASSENGER_SELECTOR_LINK_ADULTS: "Group Travel FAQs",
  FlightBookingForm__PASSENGER_SELECTOR_LINK_LAPCHILDREN: "Learn More",
  FlightBookingForm__PASSENGER_SELECTOR_LINK_OLDERCHILD: "Learn More",
  FlightBookingForm__PASSENGER_SELECTOR_OLDERCHILD_ARIA_LABEL:
    "Unaccompanied minors are restricted to nonstop and direct domestic flights.",
  FlightBookingForm__PASSENGER_SELECTOR_OLDERCHILD_CAPTION: "5-11",
  FlightBookingForm__PASSENGER_SELECTOR_OLDERCHILD_INFO:
    "Unaccompanied minors are restricted to nonstop and direct domestic flights.",
  FlightBookingForm__PASSENGER_SELECTOR_TEENS_CAPTION: "12-17",
  FlightBookingForm__PASSENGER_SELECTOR_TEENS_LABEL: "Teens",
  FlightBookingForm__PASSENGER_SELECTOR_TITLE_ADULTS: (data) =>
    `Booking more than ${data.maxPassengersCount}?`,
  FlightBookingForm__PASSENGER_SELECTOR_TITLE_LAPCHILDREN: "Baby on board?",
  FlightBookingForm__PASSENGER_SELECTOR_TITLE_OLDERCHILD: "Children flying alone?",
  FlightBookingForm__PASSENGER_SELECTOR_YOUNGERCHILD_CAPTION: "Age 0-4 (excluding lap children)",
  FlightBookingForm__PROMO_CODE_LABEL: "Promo code",
  FlightBookingForm__PROMO_CODE_ARIA_LABEL: "Promo code",
  FlightBookingForm__RADIO_BUTTON_ARIA_LIVE: (data) =>
    `RadioButton group. ${data.option} option selected. ${data.index} of ${data.length}`,
  FlightBookingForm__RECENT_SEARCHES_LABEL: "Recent searches",
  FlightBookingForm__RETURN_DATE_LABEL: "Return date*",
  FlightBookingForm__RETURN_DATE_ARIA_LABEL: "Return date in M M, D D format",
  FlightBookingForm__RETURN_BUTTON_TEXT: "RETURN",
  FlightBookingForm__ROUNDTRIP_LABEL: "Round-trip",
  FlightBookingForm__SEARCH_LOW_FARE_CALENDAR_LABEL: "Search with low fare calendar",
  FlightBookingForm__SELECT_DATE_TEXT: "Select date",
  FlightBookingForm__SHORT_DATE_MONTH_AND_DAY_FORMAT: "MM/DD",
  FlightBookingForm__SHOW_FARES_IN: "Show fares in",
  FlightBookingForm__SHOW_FARE_IN_POINTS_LABEL: "Show fares in points",
  FlightBookingForm__SUBJECT_TO_CHANGE_TEXT:
    " This date is subject to change! Please check back frequently.",
  FlightBookingForm__SWITCHEROO_BUTTON_ARIA_LABEL:
    "Click to reverse the departure and arrival airports",
  FlightBookingForm__TITLE_DATE_SELECTOR: "Select your travel dates",
  FlightBookingForm__TRIP_TYPE_ARIA_LABEL: "Trip type options",
  FlightBookingForm__TRIP_TYPE_LABEL: "Trip type",
};
